import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { inboxApi } from './api';

export const inboxKeys = {
  all: ['inbox'] as const,
  list: () => ['inbox', 'list'] as const,
};

export function useInbox() {
  return useQuery({
    queryKey: inboxKeys.list(),
    queryFn: () => inboxApi.list(),
    staleTime: 15_000,
  });
}

export function useAssignMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ emailId, serviceId }: { emailId: string; serviceId: string }) =>
      inboxApi.assign(emailId, serviceId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: inboxKeys.all });
      qc.invalidateQueries({ queryKey: ['fiscal'] });
    },
  });
}
